import React, { useRef } from 'react'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import { PersonDto } from '../api/person/models/PersonDto'
import { getProfilePicUrl, formatPersonName } from '../utils/personUtils'

interface PersonSmallPicProps {
    person: PersonDto
    size?: string
}

function PersonSmallPic({
    person,
    size = '60px',
}: PersonSmallPicProps): React.JSX.Element {
    const name = formatPersonName(person)
    const jobDetails = person.currentJobDetails

    const jobTitle = jobDetails
        ? jobDetails.variousRoles
            ? 'Various positions'
            : (jobDetails.workedAt?.jobTitle ?? 'No position')
        : 'No position'

    const companyName = jobDetails
        ? jobDetails.variousCompanies
            ? 'Various companies'
            : (jobDetails.company?.name ?? 'No company')
        : 'No company'

    // Unique tooltip ID per person
    const tooltipIdRef = useRef(
        `tooltip-${Math.random().toString(36).slice(2, 9)}`,
    )
    const tooltipId = tooltipIdRef.current

    return (
        <>
            <div className="person-small-pic-container inline-block">
                <img
                    src={getProfilePicUrl(person) || '/no-profile-pic.svg'}
                    alt={`${name} – ${jobTitle} at ${companyName}`}
                    data-tooltip-id={tooltipId}
                    style={{ width: size, height: size }}
                    className="object-cover rounded-full"
                    onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                        e.currentTarget.onerror = null // Prevent infinite loop
                        e.currentTarget.src = '/no-profile-pic.svg'
                    }}
                />
            </div>
            {/* Tooltip instance with custom content */}
            <Tooltip id={tooltipId} place="top">
                <div className="text-sm font-semibold whitespace-nowrap">
                    {name}
                </div>
                <div className="text-sm italic whitespace-nowrap">
                    {jobTitle}
                </div>
                <div className="text-sm whitespace-nowrap">{companyName}</div>
            </Tooltip>
        </>
    )
}

export default PersonSmallPic
